import axios from "axios";
import { baseurl, token } from "../../../BaseUrl";

export const loginUserApi = async (data) => {
  try {
    const res = await axios.post(`/admin/sign-in`, data);
    return { isError: false, data: res.data };
  } catch (e) {
    return { isError: true, data: e.response.data.error };
  }
};
